import { gql } from 'apollo-angular';

export const getUserByIdQuery = gql`
  query Query($id: UUID!) {
    get_user(id: $id) {
      email
      id
      external_id
      instance_id
      is_admin
      language
      mobile_number
      name
      profile_picture
      receive_authorization_request
      passcode
      password
      role {
        code
        id
        name
        role_permissions {
          permission {
            name
          }
          create
          delete
          update
          read
        }
      }
      branches {
        id
        name
        location
        code
      }
      company_id
      sub_company_id
    }
  }
`;

export const listUserQuery = `
  query List_user {
    list_user {
      active
      email
      id
      is_admin
      name
      type
      language
    }
  }
`;

export const LIST_USER_BRANCH = gql`
  query List_user_branch($equal: String) {
    list_user_branch {
      branch_id
      id
      user_id(equal: $equal)
      branch {
        name
        location
        code
        id
      }
    }
  }
`;
